import {Component, OnInit, ViewChild} from '@angular/core';
import {SuppliersService} from '../../../services/suppliers.service';
import {Observable} from 'rxjs';
import {tap} from 'rxjs/operators';
import {ActivatedRoute} from '@angular/router';
import {MatButtonToggleGroup} from "@angular/material/button-toggle";
import {FormControl} from "@angular/forms";
import {ImageService, ProleisObject} from "@proleis/proleis-rest-client";
import {RibbonsComponent} from "@proleis/proleis-web-ribbons";

@Component({
  selector: 'ps-pm-constructions',
  templateUrl: 'pm-constructions.component.html'
})
export class PmConstructionsComponent implements OnInit {

  @ViewChild(RibbonsComponent) ribbonsComponent: RibbonsComponent;
  @ViewChild('group') group: MatButtonToggleGroup;

  constructions$: Observable<ProleisObject[]>;
  statusIcons$: Observable<Map<string, string>>;

  constructionsPerProject: Map<string, ProleisObject[]> = new Map();
  constructionsForCategory: ProleisObject[];

  filterControl: FormControl = new FormControl('');

  constructor(private supplierService: SuppliersService, public route: ActivatedRoute, public is: ImageService) {
  }

  ngOnInit() {
    const aliasFields = 'PROJECT=OBJECT_ID.PARENT[TYP_ID.GUID=b514d7ec-27fa-11b2-800a-b390cd5bbe84].NAME' +
      ';CHANGE_STATUS=FREIGABE_ID.DESCRIPTION;CHANGE_ICON=FREIGABE_ID.ICON;BMNR=LINK_ID.PM_BM_NR;' +
      'STATUSTEXT=PM_STATUS_KONSTRUKTION.DESCRIPTION;CONSTSTATUS=PM_STATUS_KONSTRUKTION.DESCRIPTION;' +
      'STATUSSPEC=PM_STATUS_SPEZIFIKATION.DESCRIPTION;' +
      'PARENT_MODULE=OBJECT_ID.PARENT[TYP_ID.GUID=b514db98-27fa-11b2-800a-b390cd5bbe84].TEXT';
    this.constructions$ = this.supplierService.getPmConstructions(aliasFields).pipe(
      tap(constructions => {
        this.mapConstructionsToProject(constructions);
        const ribbons = this.getRibbons();
        if (ribbons.length > 0) {
          setTimeout(() => {
            if (this.group) {
              this.group.value = this.getCategories(ribbons[0]);
              this.getConstructionsForCategory();
            }
          });
        }
      })
    );

    this.getIconUrls();
  }

  getIconUrls() {
    this.constructions$.subscribe(constructions => {
      const iconIdentifiers = constructions.map(construction => construction.CHANGE_ICON).join(',');
      this.statusIcons$ = this.is.getIconUrls(iconIdentifiers);
    });
  }

  mapConstructionsToProject(constructions: ProleisObject[]) {
    this.constructionsPerProject = new Map();
    const uniqueProjects: string[] = [...new Set(constructions.map(construction => construction.PROJECT))];

    uniqueProjects.forEach((project: string) => {
      this.constructionsPerProject.set(project, constructions.filter(construction => construction.PROJECT === project));
    });
  }

  getRibbons() {
    return [...this.constructionsPerProject.keys()];
  }

  getCategories(ribbon: string) {
    return [...new Set(this.constructionsPerProject.get(ribbon)?.map(construction => construction.PARENT_MODULE))];
  }

  getConstructionsForCategory() {
    const ribbon = this.ribbonsComponent?.activeRibbon;
    const selectedCategory = this.group?.value;

    if (ribbon && selectedCategory) {
      this.constructionsForCategory = this.constructionsPerProject.get(ribbon)
        ?.filter(construction => selectedCategory.includes(construction.PARENT_MODULE)) || [];
    } else {
      this.constructionsForCategory = [];
    }
  }

  onButtonGroupChanged(event) {
    this.getConstructionsForCategory();
  }

  onRibbonClicked(ribbon: string) {
    if (this.group) {
      this.group.value = this.getCategories(ribbon);
    }
    this.filterControl.setValue('');
    this.getConstructionsForCategory();
  }

  isToggleChecked(category: string) {
    return this.group?.value?.includes(category);
  }
}
